import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: '대시보드',
    icon: 'bxs-dashboard',
    link: '/dashboard',
  },
  {
    id: 2,
    label: '회원관리',
    icon: 'bx-user',
    subItems: [
      {
        id: 3,
        label: '회원관리',
        link: '/users',
        parentId: 2,
      },
    ],
  },
  {
    id: 4,
    label: '클럽관리',
    icon: 'bx bx-cctv',
    subItems: [
      {
        id: 5,
        label: '클럽 관리',
        link: '/clubs',
        parentId: 4,
      },
    ],
  },
  {
    id: 6,
    label: '매출관리',
    icon: 'dripicons-graph-bar',
    link: '/sale_manager',
  },
  {
    id: 7,
    label: '게시판 관리',
    icon: 'bx bx-headphone',
    subItems: [
      {
        id: 8,
        label: '앱 메인 공지사항 관리',
        link: '/notice_main',
        parentId: 7,
      },
      {
        id: 9,
        label: '공지사항',
        link: '/notice_user',
        parentId: 7,
      },
      {
        id: 10,
        label: '관리자 공지사항',
        link: '/notice_manager',
        parentId: 7,
      },
      {
        id: 11,
        label: '1:1 문의',
        link: '/inquiry',
        parentId: 7,
      },
      {
        id: 12,
        label: '배너관리',
        link: '/banners',
        parentId: 7,
      },
    ],
  },
  {
    id: 6,
    label: '서비스 관리',
    icon: 'bx-info-circle',
    link: '/sale_manager',
    subItems: [
      {
        id: 8,
        label: '이용약관',
        link: '/info-service',
        parentId: 7,
      },
      {
        id: 8,
        label: '개인정보처리방침',
        link: '/info-privacy',
        parentId: 7,
      },
    ],
  },
];
